(function () {
    var $bizCenter = $("#bizCenterLocal");
    var didScroll = false;
    var lastScrollTop = 0;
    var headerHeight = 90; // $bizCenter.find("header").height();

    var $header = $('header');

    var MOBILEWIDTH = 768;

    $(document).ready(function(){
        //is device check
        if(document.documentElement.clientWidth > MOBILEWIDTH) {
            $bizCenter.removeClass('mobile');
        } else {
            $bizCenter.removeClass('pc').addClass('mobile');
        }

        $('.dimmed.loading').removeClass('loading');

    });

    $(window).on('scroll', function () {
        didScroll = true;
        $('header').find('nav').removeClass('mobile-on');
    });

    setInterval(function() {
        if(didScroll) {
            hasScrolled();
        }
    }, 200);

    // 배경 interval 주석
    // setInterval(function() {
    //     if ($('main').hasClass('even')) {
    //         $('main').removeClass('even');
    //         $('main').addClass('odd');
    //     } else {
    //         $('main').removeClass('odd');
    //         $('main').addClass('even');
    //     }
    // }, 5000);

    function hasScrolled() {
        var windowScrollTop = $(window).scrollTop();

        if(windowScrollTop == 0 ) {

            // mobile menu Flag
            if ($(".mobile nav").hasClass('mobile-on')) {
                $header.addClass('on');
                didScroll = false;
            }
        }

        if(Math.abs(lastScrollTop - windowScrollTop) <= headerHeight) {
            return;
        }

        if(windowScrollTop > lastScrollTop && windowScrollTop > headerHeight) {
            //console.log("스크롤 업");
            $header.removeClass('on').addClass('up');
            if(windowScrollTop == 0) {
                // $stickyFooter.removeClass().addClass('sticky-footer');
            }
        } else {
            if(windowScrollTop == 0) {
                // $header.removeClass('');
                // $stickyFooter.removeClass().addClass('sticky-footer');
            } else {
                $header.removeClass('up').addClass('on');
            }
            //console.log("스크롤 다운");
        }
        // $stickyFooter.addClass('on');
        $bizCenter.addClass('on');
        lastScrollTop = windowScrollTop;
    }

    $(window).on('resize', function () {
        if( $(this).width() > MOBILEWIDTH) {
            $bizCenter.removeClass("mobile").addClass("pc");
        } else {
            $bizCenter.removeClass('pc').addClass('mobile');
        }
    });

    $(".tab-wrap h2").on('click', function() {
        var $tablis = $(".tab-wrap h2"),
            $tabs = $(".tab");
        var $idx = $(this).index();

        $tablis.removeClass('on');
        $tabs.removeClass('on');

        if( $(this).has("a").length >= 1) {
            location.href = $(this).find("a").attr("href");
        }  else {
            $(this).addClass('on');
            $tabs.eq($idx).addClass('on');
        }
    });

})();

// Call main, total, sns
function setOn(ele) {
    var $target = $(ele);
    var $focusIn = $target.find(".focus li");
    var $setLis = $target.find(".set li");
    var $hasMobileClass = false;

    if($setLis.hasClass("m")){
        $hasMobileClass = true;
    }

    $focusIn.on("mouseenter", function() {
        var _i  = $(this).index();
        $focusIn.removeClass("on"); // hover reset
        $setLis.removeClass("on");
        $focusIn.eq(_i).addClass("on");

        if($hasMobileClass){
            _i *= 2;
        }

        $setLis.eq(_i).addClass("on");
    })
};

(function() {
    $(".m-close").on('click', function(e) {
        e.preventDefault();
        var $header = $('header');
        $header.find('nav').toggleClass('mobile-on');
        $header.removeClass('on');

    });
})();

